import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { deepMix } from '@antv/util';
import { column, columnOf } from './utils/helper';
/**
 * Assume color channel is series channel.
 */
export var MaybeSeries = function MaybeSeries() {
  return function (I, mark) {
    var encode = mark.encode;
    var series = encode.series,
      color = encode.color;
    if (series !== undefined || color === undefined) return [I, mark];
    var _columnOf = columnOf(encode, 'color'),
      _columnOf2 = _slicedToArray(_columnOf, 2),
      C = _columnOf2[0],
      fc = _columnOf2[1];
    return [I, deepMix({}, mark, {
      encode: {
        series: column(C, fc)
      }
    })];
  };
};
MaybeSeries.props = {};